export const forEcommerceGenerate = [
	{
		icon: '✌️',
		title: 'forEcommerceData_title1',
		subtitle: 'forEcommerceData_subtitle1',
	},
	{
		icon: '🎨',
		title: 'forEcommerceData_title2',
		subtitle: 'forEcommerceData_subtitle2',
	},
	{
		icon: '🚀',
		title: 'forEcommerceData_title3',
		subtitle: 'forEcommerceData_subtitle3',
	},
	{
		icon: '🎯',
		title: 'forEcommerceData_title4',
		subtitle: 'forEcommerceData_subtitle4',
	},
];
